module.exports = __webpack_public_path__ + "static/img/car.e761686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car.png
// module id = 5AjI
// module chunks = 1